<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow" 
			:dialog-class="''"
			:ok-title="'Search'"
			ok-variant="success" 
			:cancel-title="'Clear'" 
			@ok="getApprovalTypes"
			@hidden="resetModal"
			>
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="filter-name" size="sm" :model.sync="filter.name" />
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay
					:show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right"
					>
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>
		<b-row class="mb-2 d-sm-none d-md-flex">
			<b-col class="pt-1">
				<span class="function-title">Approval Type</span>
			</b-col>
			<b-col>
				<span class="float-right">
					<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
						<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" :href="`files/ApprovalType/ApprovalType.xlsx`"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
						<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
						<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
					</b-dropdown>
					<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
						:show="isCreateBusy"
						opacity="0.6"
						spinner-small
						spinner-variant="default"
						class="d-inline">
						<b-button class="btn-create btn-fill-success" @click="createData" size="sm">
							<b-icon-plus-square class="mr-1"></b-icon-plus-square>
							Create New</b-button>
					</b-overlay>
				</span>
				<Portal to="app-navbar-bottom">
					<span class="float-right">
						<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
							:show="isCreateBusy"
							opacity="0.6"
							spinner-small
							spinner-variant="default"
							class="d-inline">
							<b-button class="btn-create btn-fill-success" @click="createData" size="sm">
								<b-icon-plus-square class="mr-1"></b-icon-plus-square>
								Create New</b-button>
						</b-overlay>
					</span>
				</Portal>
			</b-col>
		</b-row>
		<div class="table-corner">
			<div class="table-action-button">
				<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				<b-overlay v-if="isShowDeleteButton"
					:show="isDeleteBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block">
					<click-confirm>
						<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
					</click-confirm>
				</b-overlay>
				<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
				<span class="d-inline d-md-none">
					<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
					<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
				</span>
				<span>
					<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
					<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
				</span>
			</div>
			<b-table :stacked="isStacked" id="table-list-approvaltype" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="approvalTypes" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
				<template #empty>
					<app-no-data-image />
				</template>
				<template #table-busy v-if="approvalTypes.length <= 0">
					<app-no-data-image :animate="true" />
				</template>
				<template v-slot:head(front-action)>
					<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
				</template>
				<template v-slot:head(actions)>
					<b-button-group class="float-right"  size="sm">
					</b-button-group>
				</template>
				<template #top-row v-if="isShowFilter">
					<b-th></b-th>
					<b-th stacked-heading="Name">
						<b-form-input id="input-name-table" @input="getApprovalTypesWithoutLoading" v-model="filter.name" size="sm"></b-form-input>
					</b-th>
					<b-th stacked-heading="Description">
						<b-form-input id="input-description-table" @input="getApprovalTypesWithoutLoading" v-model="filter.description" size="sm"></b-form-input>
					</b-th>
					<b-th stacked-heading="Interface Name">
						<b-form-input id="input-interface-name-table" @input="getApprovalTypesWithoutLoading" v-model="filter.interfaceName" size="sm"></b-form-input>
					</b-th>
					<b-th stacked-heading="Select All">
						<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
					</b-th>
				</template>
				<template v-slot:cell(no)="row">
					{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
				</template>
				<template v-slot:cell(name)="row">
						<a @click="() => ( $router.push({ name: 'approvaltypedetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.name != null && row.item.name != "" ? row.item.name.slice(0, 30) + (row.item.name.length > 30 ? "..." : "" ) : "" }}
						</a>
					</template>
				<template v-slot:cell(front-action)="row">
					<div class="d-flex justify-content-center ml-2">
						<b-form-checkbox :id="'input-is-print-' + (row.index + 1)" @change="toggleIsPrint(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
					</div>
				</template>
				<template v-slot:cell(actions)="row" >
					<div class="div-actions float-right">
					<b-button size="sm" v-if="(userRole != null ? userRole.allowUpdate : false)" :to="{path: '/approvaltype/edit/' + row.item.id }" variant ="success"  class="mr-2 btn-xs">
						<b-icon-pencil></b-icon-pencil>
					</b-button>
					<b-overlay
						v-if="(userRole != null ? userRole.allowDelete : false)"
						:show="busy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block"
						>
						<click-confirm>
						<b-button size="sm" variant="danger" @click="deleteData(row.item.id)" class="mr-2 btn-xs">
							<b-icon-trash></b-icon-trash>
						</b-button>
						</click-confirm>
					</b-overlay>
					<b-button size="sm" v-if="(userRole != null ? userRole.allowRead : false)" variant="primary" class="mr-2 mt-md-2 mt-lg-0 btn-xs" :to="{path: '/approvaltype/detail/' + row.item.id }" >
						<b-icon-eye-fill></b-icon-eye-fill>
					</b-button>
					<b-button size="sm" v-if="(userRole != null ? userRole.allowPrint : false)" variant="light"  @click="printSingleData(row.item.id)" class="mr-2 mt-md-2 mt-lg-0 btn-xs">
						<b-icon-printer-fill></b-icon-printer-fill>
					</b-button>
					<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" class="d-inline" :id="'input-is-print-' + (row.index + 1)" @change="toggleIsPrint(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))" ></b-form-checkbox>
					</div>
				</template>
			</b-table>
		</div>
		<b-row>
			<b-col cols="12" class="paging-container">
				<div>
					<b-row>
						<b-col cols="12">
							<b-pagination
								class="btn-paging paging-page-size"
								v-model="currentPage"
								:total-rows="(approvalTypesPaging != null ? approvalTypesPaging.dataCount : 0)"
								:per-page="(approvalTypesPaging != null ? approvalTypesPaging.pageSize : 0)"
								aria-controls="my-table"
							>
								<template #first-text><b-icon-chevron-bar-left /></template>
								<template #prev-text><b-icon-chevron-left /></template>
								<template #next-text><b-icon-chevron-right /></template>
								<template #last-text><b-icon-chevron-bar-right /></template>
							</b-pagination>
							<span class="paging-page-size">
								<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
									<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
										{{ item.text }}
									</b-dropdown-item>
								</b-dropdown>
							</span>
						</b-col>
					</b-row>
				</div>
			</b-col>
		</b-row>
		<Upload
		:openPopup="showPopupUpload"
		@resetMethod="resetModalUpload"
		@uploadButtonMethod="uploadData"
		/>
		<PopupDownload
		:openPopup="showPopupDownload"
		:processId="processId"
		@resetModalMethod="resetModal"
		label= "Popup Download"
		:contentLabel = "popupDownloadLabel"
		/>
		<PopupPDF
		:openPopup="isShowPopupPDF"
		:pdfUrl="pdfUrl"
		@resetModalMethod="resetModal"
		label= "Popup PDF"
		/>
		
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';
</style>
<script>
import ApprovalType from '@/models/ApprovalType/ApprovalType';
import ApprovalTypeList from '@/models/ApprovalType/ApprovalTypeList';
import ApprovalTypeFilter from '@/filters/ApprovalType/ApprovalTypeFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {ApprovalType, ApprovalTypeList, ApprovalTypeFilter, AppInputTextbox,AppInputTextarea,PopupDownload,PopupPDF,Upload,PopupDataEditNotification,},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}}, 
				{"name": {}, "class" : "th-name first-child", "label" : "Name", key: 'name', sortable: true}, 
				{"description": {}, "class" : "th-description last-child", "label" : "Description", key: 'description', sortable: true}, 
				{"interfaceName": {}, "class" : "th-interface-name d-stack-none", "label" : "Interface Name", key: 'interfaceName', sortable: true}, 
				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			approvalTypes: [],
			approvalTypesPaging: {},
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
		}
	},
	methods : {
		getApprovalTypes : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			ApprovalType.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.approvalTypes = result.data
					this.approvalTypesPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getApprovalTypesWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			ApprovalType.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.approvalTypes = result.data
					this.approvalTypesPaging = result
				}
			})
			.catch(error => {});
		},
		resetFilter() {
			this.filter = new ApprovalTypeFilter();
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getApprovalTypes();
		},
		toggleIsPrint(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ApprovalType.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ApprovalType.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			if (this.sortBy != null) {
					this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.isDownloadDataBusy = true;
			ApprovalType.downloadData(this, this.filter, this.sortingBy).then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			}).catch(error => { this.isDownloadDataBusy = false; })
		},
		createData() {
			this.$router.push({ name: 'approvaltypecreate' });
		},
		deleteData(id) {
			ApprovalType.deleteData(this, id).then(result => {
				if (result)
				{
					this.getApprovalTypes();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ApprovalType.deleteMultipleData(this).then(result => {
					this.getApprovalTypes();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
		scrollRight() {
			var tableApprovalTypeParent = document.getElementById('table-list-approvaltype').parentNode;
			tableApprovalTypeParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableApprovalTypeParent.scrollWidth - tableApprovalTypeParent.offsetWidth) == Math.ceil(tableApprovalTypeParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableApprovalTypeParent = document.getElementById('table-list-approvaltype').parentNode;
			tableApprovalTypeParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableApprovalTypeParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ApprovalTypeFilter();
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Approval Type"
		];
		this.getApprovalTypes();
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getApprovalTypes();
			}
		},
		sortDesc: {
			handler: function() {
				this.getApprovalTypes();
			}
		},
		currentPage: {
			handler: function() {
				this.getApprovalTypes();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getApprovalTypes();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ApprovalType.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "approvaltypeindex") {
					this.getApprovalTypesWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "approval_type").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
